import { CommunicationTemplateType } from "@bbj-types/communication/enum";
import { EmailModalTitle } from "./emailModalContent/title";
import { SmsModalTitle } from "./smsModalContent/title";

export interface INotifyCandidateModalTitleProps {
  type: CommunicationTemplateType;
}

export const NotifyCandidateModalTitle = ({ type }: INotifyCandidateModalTitleProps) => {
  switch (type) {
    case CommunicationTemplateType.EMAIL:
      return <EmailModalTitle />;
    case CommunicationTemplateType.SMS:
      return <SmsModalTitle />;
    default:
      return null;
  }
};
